<ng-container *ngIf="isMobile; else isDesktop">
  <ng-container *ngIf="isModal; else isMobile">
    <div
      class="product-sizes-modal">
      <ng-container
        *ngIf="!!sizeTypeSelected;">
        <button
          class="product-sizetype-title"
          (click)="removeSizeType()"
          [attr.aria-label]="'Volver al selector de tallas'">
          <svg
            viewBox="0 0 21 16"
            fill="none"
            aria-hidden="true"
            focusable="false">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M8.6448 0.646447C8.84007 0.841709 8.84007 1.15829 8.6448 1.35355L2.48836 7.51H19.7812C20.0574 7.51 20.2812 7.73386 20.2812 8.01C20.2812 8.28614 20.0574 8.51 19.7812 8.51H2.48714L8.64506 14.6767C8.84018 14.8721 8.83995 15.1887 8.64455 15.3838C8.44915 15.5789 8.13257 15.5787 7.93744 15.3833L0.927445 8.3633C0.73242 8.168 0.732533 7.85161 0.927697 7.65645L7.9377 0.646447C8.13296 0.451184 8.44954 0.451184 8.6448 0.646447Z"
              fill="black"/>
          </svg>
          <span
            class="product-size-title product-size-title-back">
            {{ piece?.settings?.general?.titleSizeMobile}} {{ hasToShowInternationalSizeName ? sizeTypeSelected[0].internationalSizeName : sizeTypeSelected[0].name }}
          </span>
        </button>
      </ng-container>
      <ng-container *ngIf="!!sizeTypeSelected; else showProductSizeList">
        <ng-container *ngTemplateOutlet="sizeTypeSelectedList"></ng-container>
      </ng-container>
      <ng-template #showProductSizeList>
        @if(piece!.settings?.general?.productAddToCartText) {
          <div
            class="wysiwyg select-size-text">
            <render-wysiwyg
              [html]="piece!.settings!.general!.productAddToCartText"
              [country]="country"
              [lang]="lang"
              [piece]="piece">
            </render-wysiwyg>
          </div>
        }
        @if(product?.colors?.length && product.colors[0]?.modelinfo?.height && product.colors[0]?.modelinfo?.size){
          <div
            class="model-data">
            <span>{{ piece?.settings?.general?.modelHeight }} {{ product.colors[0]?.modelinfo?.height }}</span>
            <span> - </span>
            <span>{{ piece?.settings?.general?.modelSize }} {{ product.colors[0]?.modelinfo?.size }}</span>
          </div>
        }
        <ng-container *ngTemplateOutlet="productSizeList"></ng-container>
      </ng-template>
    </div>
  </ng-container>
  <ng-template #isMobile>
    <button
      *ngIf="hasToDisplayProductSizesSelector && !!product?.colors?.length"
      class="product-size-open-modal"
      (click)="openSizeSelectorModal()"
      (keydown.enter)="handleEnterKey($event)"
      [attr.aria-label]="'Seleccionar talla para ' + (product?.name || 'producto')"
      [attr.aria-haspopup]="true"
      [attr.aria-expanded]="false">
      <svg
        class="basket-icon"
        viewBox="0 0 32 32"
        fill="none"
        aria-hidden="true"
        focusable="false">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.7222 4.88479C15.1662 4.71871 15.6478 4.63281 16.135 4.63281C16.6222 4.63281 17.1038 4.71871 17.5477 4.88479C17.9917 5.05088 18.388 5.29334 18.7101 5.59606C19.0322 5.89878 19.2728 6.25483 19.4159 6.64053C19.5553 7.01633 19.6101 8.0229 19.5556 8.41322L23.4317 8.44158C23.7456 8.44158 24 8.6523 24 8.91224V20.9745C24 21.5987 23.7006 22.1972 23.1678 22.6386C22.6349 23.0799 21.9122 23.3278 21.1587 23.3278H10.8413C10.0878 23.3278 9.36506 23.0799 8.83221 22.6386C8.29935 22.1972 8 21.5987 8 20.9745V8.91224C8 8.6523 8.25442 8.44158 8.56827 8.44158L12.7254 8.41322V8.44158C12.6709 8.05126 12.7146 7.01633 12.8541 6.64053C12.9972 6.25483 13.2378 5.89878 13.5599 5.59606C13.882 5.29334 14.2782 5.05088 14.7222 4.88479ZM13.8619 8.41322H18.408C18.408 8.39343 18.4095 8.41513 18.4125 8.3955C18.4535 8.12775 18.4252 7.17502 18.3295 6.91704C18.2338 6.65906 18.0728 6.4209 17.8574 6.21842C17.6419 6.01594 17.3769 5.85376 17.0799 5.74267C16.783 5.63158 16.4608 5.57413 16.135 5.57413C15.8091 5.57413 15.487 5.63158 15.19 5.74267C14.893 5.85376 14.628 6.01594 14.4126 6.21842C14.1971 6.4209 14.0362 6.65905 13.9405 6.91704C13.8447 7.17502 13.8164 8.08629 13.8574 8.35404C13.8604 8.37367 13.8619 8.39343 13.8619 8.41322ZM9.13653 9.38289V20.9745C9.13653 21.349 9.31615 21.7082 9.63586 21.973C9.95557 22.2378 10.3892 22.3865 10.8413 22.3865H21.1587C21.6108 22.3865 22.0444 22.2378 22.3641 21.973C22.6839 21.7082 22.8635 21.349 22.8635 20.9745V9.38289H9.13653Z"
          fill="black"
        />
      </svg>
    </button>
  </ng-template>
</ng-container>
<ng-template #isDesktop>
  <div
    class="product-options-container"
    role="group">
    <div
      class="product-size-container"
      *ngIf="hasToDisplayProductSizesSelector && !!product?.colors?.length"
      >
      <ng-container
        *ngIf="!!sizeTypeSelected; else showTitle">
        <button
          class="product-sizetype-title"
          *ngIf="!!sizeTypeSelected"
          (click)="removeSizeType()"
          (keydown.enter)="handleBackButtonEnter($event)"
          [attr.aria-label]="'Volver a lista de tallas'"
          tabindex="0">
          <svg
            viewBox="0 0 11 18"
            fill="none">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M10.2989 17.2114C9.9266 17.5545 9.32298 17.5545 8.95068 17.2114L0.713891 9.62141C0.341591 9.27834 0.341591 8.72212 0.713891 8.37905L8.95069 0.789009C9.32299 0.445942 9.9266 0.445942 10.2989 0.789009C10.6712 1.13208 10.6712 1.6883 10.2989 2.03136L2.73621 9.00023L10.2989 15.9691C10.6712 16.3122 10.6712 16.8684 10.2989 17.2114Z"/>
          </svg>
          <span
            class="product-size-title product-size-title-back">
            {{ hasToShowInternationalSizeName ? sizeTypeSelected[0].internationalSizeName : sizeTypeSelected[0].name }}
          </span>
        </button>
      </ng-container>
      <ng-template #showTitle>
        <ng-container
          *ngIf="!alternativeSizesNames.length; else showAlternativeSizeNames">
          <span
            class="product-size-title">
            {{ piece?.settings?.general?.titleSize }}
          </span>
        </ng-container>
      </ng-template>
      <ng-template #showAlternativeSizeNames>
        <div
          class="toggle-size-container">
          <span
            class="toggle-option"
            [ngClass]="{'toggle-option-active': !hasToShowInternationalSizeName}">
            {{ alternativeSizesNames[0] }}
          </span>
          <label
            class="toggle-size"
            [attr.aria-label]="'Cambiar entre ' + alternativeSizesNames[0] + ' y ' + alternativeSizesNames[1]">
            <input
              (change)="toggleInternationalSizeName()"
              type="checkbox"
              [attr.aria-checked]="hasToShowInternationalSizeName"/>
            <span
              [ngClass]="{'option-active': hasToShowInternationalSizeName}">
            </span>
          </label>
          <span
            class="toggle-option"
            [ngClass]="{'toggle-option-active': hasToShowInternationalSizeName}">
            {{ alternativeSizesNames[1] }}
          </span>
        </div>
      </ng-template>
      <div
        *ngIf="hasToDisplayProductSizesAdditionalInfo && product?.additionalInfo"
        class="size-recommendation">
        <render-wysiwyg
          [html]="product!.additionalInfo! | additionalInfo:piece!"
          [country]="country"
          [lang]="lang"
          [piece]="piece">
        </render-wysiwyg>
      </div>
      <ng-container *ngIf="!!sizeTypeSelected; else showProductSizeList">
        <ng-container *ngTemplateOutlet="sizeTypeSelectedList"></ng-container>
      </ng-container>
      <ng-template #showProductSizeList>
        <ng-container *ngTemplateOutlet="productSizeList"></ng-container>
      </ng-template>
    </div>
  </div>
</ng-template>

<ng-template #productSizeList>
  <div
    *ngIf="isMobile && alternativeSizesNames.length > 0"
    class="toggle-size-container-mobile">
    <button
      (click)="toggleInternationalSizeName()"
      class="toggle-option"
      [ngClass]="{'toggle-option-active': !hasToShowInternationalSizeName}">
      {{ alternativeSizesNames[0] }}
    </button>
    <button
      (click)="toggleInternationalSizeName()"
      class="toggle-option"
      [ngClass]="{'toggle-option-active': hasToShowInternationalSizeName}">
      {{ alternativeSizesNames[1] }}
    </button>
  </div>
  <div class="product-size-list">
    <ng-container
      *ngFor="let sizes of productSizes; let i = index; trackBy: trackBySize">
      <div
        class="product-size-group">
        <button
          class="product-size-button"
          [ngClass]="{'product-size-clicked': sizes[0] === selectedSize}"
          [disabled]="!(sizes | stockValue)"
          [value]="sizes[0].name"
          (click)="sizes.length === 1 ? onProductCartClick(sizes[0]) : showSizeType(sizes)"
          (keydown.enter)="handleSizeButtonEnter($event, sizes)"
          [attr.aria-selected]="sizes[0] === selectedSize"
          [attr.aria-disabled]="sizes[0].visibilityValue !== 'SHOW'"
          [attr.aria-describedby]="'size-desc-' + i + '-' + product?.id"
          tabindex="-1">
            {{ product.colors[0].sizes!.length > 1 ? (hasToShowInternationalSizeName ? sizes[0].internationalSizeName : sizes[0].name) : piece?.settings?.general?.oneSizeText }}
        </button>
        <ng-container *ngIf="hasToDisplayProductSizesLastUnitsWarning">
          <div
            *ngIf="sizes | lastUnitsLabel: piece!"
            class="threshold-label">
            <render-wysiwyg
              class="threshold-label-text"
              [html]="sizes | lastUnitsLabel: piece!"
              [country]="country"
              [lang]="lang"
              [piece]="piece">
            </render-wysiwyg>
            <svg
              viewBox="0 0 30 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M19.8882 7.68326C18.4411 6.71631 16.7397 6.2002 14.9992 6.2002C12.6661 6.20284 10.4294 7.13083 8.77961 8.78058C7.12986 10.4303 6.20187 12.6671 6.19922 15.0002C6.19922 16.7407 6.71533 18.4421 7.68229 19.8892C8.64925 21.3364 10.0236 22.4643 11.6316 23.1303C13.2396 23.7964 15.009 23.9707 16.716 23.6311C18.4231 23.2916 19.9911 22.4534 21.2218 21.2227C22.4525 19.992 23.2906 18.424 23.6301 16.717C23.9697 15.01 23.7954 13.2406 23.1294 11.6326C22.4633 10.0246 21.3354 8.65022 19.8882 7.68326ZM9.55463 6.85179C11.1662 5.77496 13.061 5.2002 14.9992 5.2002C17.5983 5.2002 20.091 6.23269 21.9289 8.07055C23.7667 9.90841 24.7992 12.4011 24.7992 15.0002C24.7992 16.9385 24.2245 18.8332 23.1476 20.4448C22.0708 22.0564 20.5402 23.3125 18.7495 24.0542C16.9588 24.796 14.9884 24.99 13.0873 24.6119C11.1863 24.2338 9.44013 23.3004 8.06958 21.9298C6.69902 20.5593 5.76566 18.8131 5.38753 16.9121C5.00939 15.0111 5.20346 13.0406 5.9452 11.2499C6.68694 9.45918 7.94303 7.92863 9.55463 6.85179ZM15.5642 8.87019C15.5642 8.53606 15.2934 8.26519 14.9592 8.26519C14.6251 8.26519 14.3542 8.53606 14.3542 8.87019V14.9102C14.3542 15.0707 14.418 15.2245 14.5314 15.338L18.2114 19.018C18.4477 19.2543 18.8308 19.2543 19.067 19.018C19.3033 18.7817 19.3033 18.3987 19.067 18.1624L15.5642 14.6596V8.87019Z"
                fill="#e08914">
              </path>
            </svg>
          </div>
        </ng-container>
        <div
          *ngIf="hasToDisplayViewSimilarProducts"
          class="view-similar"
          (click)="$event.stopPropagation(); onViewSimilarClick(sizes[0])">
            <render-wysiwyg
              [html]="piece! | viewSimilarProducts:sizes[0].visibilityValue === 'SHOW'"
              [country]="country"
              [lang]="lang"
              [piece]="piece">
            </render-wysiwyg>
        </div>
        <ng-container
          *ngIf="productSizesAllBackSoon[i]">
          <div
            *ngIf="isMobile"
            class="stock-description">
            BACK SOON
          </div>
          <button
            (click)="onBackSoonClick(sizes)"
            class="back-soon"
            [attr.aria-label]="'Notificarme cuando la talla ' + sizes[0].name + ' esté disponible'"
            [attr.aria-haspopup]="true"
            tabindex="-1">
              <render-wysiwyg
                class="back-soon-text"
                [html]="piece?.settings?.general?.backSoonText | titlecase"
                [country]="country"
                [lang]="lang"
                [piece]="piece">
              </render-wysiwyg>
              <svg
                viewBox="0 0 18 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
                focusable="false">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M2.34512 1.15781C2.0707 1.15781 1.84824 1.38027 1.84824 1.65469V2.04607L8.48898 6.88627C8.48929 6.88649 8.48961 6.88672 8.48992 6.88695C8.74362 7.06964 9.04834 7.16795 9.36099 7.16795C9.67339 7.16795 9.97787 7.0698 10.2314 6.8874L16.8042 2.06416V1.65469C16.8042 1.38027 16.5817 1.15781 16.3073 1.15781H2.34512ZM16.8042 3.29677L12.59 6.38927L16.8042 9.90112V3.29677ZM16.8042 11.1947L11.7645 6.99498L10.8144 7.69224C10.3912 7.99746 9.88272 8.1617 9.36099 8.1617C8.83926 8.1617 8.33077 7.99744 7.90763 7.69223L7.90563 7.69079L6.92263 6.97431L1.84824 11.203V11.3239C1.84824 11.5983 2.0707 11.8208 2.34512 11.8208H16.3073C16.5817 11.8208 16.8042 11.5983 16.8042 11.3239V11.1947ZM1.84824 9.9094L6.09459 6.37078L1.84824 3.27577V9.9094ZM0.854492 1.65469C0.854492 0.831438 1.52187 0.164062 2.34512 0.164062H16.3073C17.1306 0.164062 17.7979 0.831438 17.7979 1.65469V11.3239C17.7979 12.1471 17.1306 12.8145 16.3073 12.8145H2.34512C1.52187 12.8145 0.854492 12.1471 0.854492 11.3239V1.65469Z"
                  fill="black"
                />
              </svg>
          </button>
        </ng-container>
      </div>
    </ng-container>
  </div>
</ng-template>
<ng-template #sizeTypeSelectedList>
  <div
    class="product-size-list size-type-list">
    <ng-container
      *ngFor="let size of sizeTypeSelected; trackBy: trackBySize">
      <div
        class="product-size-group size-type-group">
        <button
          class="product-size-button"
          [ngClass]="{'product-size-clicked': size === selectedSize, 'product-size-button-mobile': isMobile}"
          [disabled]="size.visibilityValue === 'HIDDEN' || size.visibilityValue === 'BACK_SOON' || size.visibilityValue === 'COMING_SOON' || size.visibilityValue === 'SOLD_OUT'"
          [value]="size.name"
          (click)="$event.stopPropagation(); onProductCartClick(size)"
          [attr.aria-selected]="size === selectedSize"
          [attr.aria-disabled]="size.visibilityValue !== 'SHOW'"
          [attr.aria-label]="'Talla ' + (size.sizeType | sizeTypeLabel:piece!:false) + (size.visibilityValue !== 'SHOW' ? ', no disponible' : '')"
          [attr.aria-describedby]="'size-type-desc-' + size.name + '-' + product?.id">
          {{ size.sizeType | sizeTypeLabel:piece!:false }}
        </button>
        <ng-container *ngIf="hasToDisplayProductSizesLastUnitsWarning">
          <div
            *ngIf="size | lastUnitsLabel:piece!"
            class="threshold-label">
            <render-wysiwyg
              class="threshold-label-text"
              [html]="size | lastUnitsLabel:piece!"
              [country]="country"
              [lang]="lang"
              [piece]="piece">
            </render-wysiwyg>
            <svg
              viewBox="0 0 30 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M19.8882 7.68326C18.4411 6.71631 16.7397 6.2002 14.9992 6.2002C12.6661 6.20284 10.4294 7.13083 8.77961 8.78058C7.12986 10.4303 6.20187 12.6671 6.19922 15.0002C6.19922 16.7407 6.71533 18.4421 7.68229 19.8892C8.64925 21.3364 10.0236 22.4643 11.6316 23.1303C13.2396 23.7964 15.009 23.9707 16.716 23.6311C18.4231 23.2916 19.9911 22.4534 21.2218 21.2227C22.4525 19.992 23.2906 18.424 23.6301 16.717C23.9697 15.01 23.7954 13.2406 23.1294 11.6326C22.4633 10.0246 21.3354 8.65022 19.8882 7.68326ZM9.55463 6.85179C11.1662 5.77496 13.061 5.2002 14.9992 5.2002C17.5983 5.2002 20.091 6.23269 21.9289 8.07055C23.7667 9.90841 24.7992 12.4011 24.7992 15.0002C24.7992 16.9385 24.2245 18.8332 23.1476 20.4448C22.0708 22.0564 20.5402 23.3125 18.7495 24.0542C16.9588 24.796 14.9884 24.99 13.0873 24.6119C11.1863 24.2338 9.44013 23.3004 8.06958 21.9298C6.69902 20.5593 5.76566 18.8131 5.38753 16.9121C5.00939 15.0111 5.20346 13.0406 5.9452 11.2499C6.68694 9.45918 7.94303 7.92863 9.55463 6.85179ZM15.5642 8.87019C15.5642 8.53606 15.2934 8.26519 14.9592 8.26519C14.6251 8.26519 14.3542 8.53606 14.3542 8.87019V14.9102C14.3542 15.0707 14.418 15.2245 14.5314 15.338L18.2114 19.018C18.4477 19.2543 18.8308 19.2543 19.067 19.018C19.3033 18.7817 19.3033 18.3987 19.067 18.1624L15.5642 14.6596V8.87019Z"
                fill="#e08914">
              </path>
            </svg>
          </div>
        </ng-container>
        <ng-container
          *ngIf="size.backSoon === '1'">
          <div
            *ngIf="isMobile"
            class="stock-description">
            BACK SOON
          </div>
          <button
            (click)="onBackSoonClick(sizeTypeSelected!)"
            class="back-soon"
            tabindex="-1">
              <render-wysiwyg
                class="back-soon-text"
                [html]="piece?.settings?.general?.backSoonText | titlecase"
                [country]="country"
                [lang]="lang"
                [piece]="piece">
              </render-wysiwyg>
              <svg
                viewBox="0 0 18 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M2.34512 1.15781C2.0707 1.15781 1.84824 1.38027 1.84824 1.65469V2.04607L8.48898 6.88627C8.48929 6.88649 8.48961 6.88672 8.48992 6.88695C8.74362 7.06964 9.04834 7.16795 9.36099 7.16795C9.67339 7.16795 9.97787 7.0698 10.2314 6.8874L16.8042 2.06416V1.65469C16.8042 1.38027 16.5817 1.15781 16.3073 1.15781H2.34512ZM16.8042 3.29677L12.59 6.38927L16.8042 9.90112V3.29677ZM16.8042 11.1947L11.7645 6.99498L10.8144 7.69224C10.3912 7.99746 9.88272 8.1617 9.36099 8.1617C8.83926 8.1617 8.33077 7.99744 7.90763 7.69223L7.90563 7.69079L6.92263 6.97431L1.84824 11.203V11.3239C1.84824 11.5983 2.0707 11.8208 2.34512 11.8208H16.3073C16.5817 11.8208 16.8042 11.5983 16.8042 11.3239V11.1947ZM1.84824 9.9094L6.09459 6.37078L1.84824 3.27577V9.9094ZM0.854492 1.65469C0.854492 0.831438 1.52187 0.164062 2.34512 0.164062H16.3073C17.1306 0.164062 17.7979 0.831438 17.7979 1.65469V11.3239C17.7979 12.1471 17.1306 12.8145 16.3073 12.8145H2.34512C1.52187 12.8145 0.854492 12.1471 0.854492 11.3239V1.65469Z"
                  fill="black"
                />
              </svg>
          </button>
        </ng-container>
        <span
          class="size-type-description">
          {{ size.sizeType | sizeTypeLabel:piece!:true }}
        </span>
      </div>
    </ng-container>
  </div>
</ng-template>
